export enum ProjectThemeActionKeys {
    Edit = 'edit-theme',
    Delete = 'delete-theme',
    SetAsActive = 'set-as-active-theme',
}

